import { render, staticRenderFns } from "./LandtrustStatistics.vue?vue&type=template&id=1c3fee1b"
import script from "./LandtrustStatistics.vue?vue&type=script&lang=js"
export * from "./LandtrustStatistics.vue?vue&type=script&lang=js"
import style0 from "./LandtrustStatistics.vue?vue&type=style&index=0&id=1c3fee1b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports